import { IsCompiledStatus } from "./waterMeasurementProtocol.type";

/**
 * Persisterad av servern och omräknad vid varje skrivning —
 * frontend får aldrig sätta den. Ordningen speglar stegkedjan.
 */
export enum WaterMeasurementProtocolStatus {
  MissingPointData = "MissingPointData",
  SeparatorDataSupplied = "SeparatorDataSupplied",
  MeasurementCompleted = "MeasurementCompleted",
  SampleSentToLab = "SampleSentToLab",
  LabResponded = "LabResponded",
  ReportCompiled = "ReportCompiled",
}

const STATUS_ORDER: WaterMeasurementProtocolStatus[] = [
  WaterMeasurementProtocolStatus.MissingPointData,
  WaterMeasurementProtocolStatus.SeparatorDataSupplied,
  WaterMeasurementProtocolStatus.MeasurementCompleted,
  WaterMeasurementProtocolStatus.SampleSentToLab,
  WaterMeasurementProtocolStatus.LabResponded,
  WaterMeasurementProtocolStatus.ReportCompiled,
];

/**
 * Hur långt i stegkedjan protokollet nått (0–5).
 * Steg N är upplåst när rank >= N, klart när rank >= N + 1.
 */
export const waterMeasurementProtocolStatusRank = (
  status: WaterMeasurementProtocolStatus,
): number => STATUS_ORDER.indexOf(status);

export const waterMeasurementProtocolStatusLabel = (
  status: WaterMeasurementProtocolStatus,
): string => {
  switch (status) {
    case WaterMeasurementProtocolStatus.MissingPointData:
      return "Saknar punktdata";
    case WaterMeasurementProtocolStatus.SeparatorDataSupplied:
      return "Påbörjad";
    case WaterMeasurementProtocolStatus.MeasurementCompleted:
      return "Provtagning genomförd";
    case WaterMeasurementProtocolStatus.SampleSentToLab:
      return "Under analys";
    case WaterMeasurementProtocolStatus.LabResponded:
      return "Analyserad";
    case WaterMeasurementProtocolStatus.ReportCompiled:
      return "Klar";
  }
};

export const getIsCompiledLabel = (
  value: IsCompiledStatus | null | undefined,
): string => {
  switch (value) {
    case IsCompiledStatus.Yes:
      return "Ja";
    case IsCompiledStatus.No:
      return "Nej";
    case IsCompiledStatus.NotRelevant:
      return "Ej aktuellt";
    default:
      return "-";
  }
};
